module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [(_vm.attachments.length > 0) ? _c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "columns is-multiline"
  }, [_vm._l((_vm.attachments), function(file) {
    return [_c('div', {
      staticClass: "column is-6",
      staticStyle: {
        "text-align": "center"
      }
    }, [(file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg') ? [_c('a', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "href": file['url'],
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": file['url'],
        "alt": "",
        "width": "90%"
      }
    })])] : [_c('a', {
      staticStyle: {
        "border-bottom": "none"
      },
      attrs: {
        "href": file['url'],
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-o fa-4",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n                        " + _vm._s(file['file'].split('/')[3]) + "\n                      ")])]], 2)]
  })], 2)]) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v("Files")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66a48fe4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/customer/CommentAttachments.vue
// module id = 1147
// module chunks = 39